export default {
    app:{
        title: 'Aurora Catch',
        subheader: 'Northern Lights Hunting Assistant App',
        feature_1: 'See an estimate of the current level of geomagnetic activity and the likelihood of aurora in your area',
        feature_2: 'Predict the probability of aurora from 50 minutes to 2 hours ahead',
        feature_3: 'Receive NOAA SWPC alerts for predicted geomagnetic activity indices',
        feature_4: 'View solar wind parameter graphs',
        feature_5: 'View sky cameras online',
        delete_account_button: 'Delete account',
        delete_account_title: 'Are you sure you want to delete your account?',
        go_back: 'Go back',
        yes: 'Yes',
        delete_success: 'Account successfully deleted',
        delete_fail: 'Failed to delete account',
    },
}
